// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"aae05bc1","353":"fe9c079c"}[chunkId] + ".chunk.css";
};